import {
  ShieldCheck,
  Clock,
  Users,
  Zap,
  Globe,
  Headphones,
} from "lucide-react";

function WhyChooseUs() {
  const services = [
    {
      title: "Trusted & Secure",
      description:
        "We prioritize security and reliability to ensure your data and projects are always safe.",
      icon: ShieldCheck,
    },
    {
      title: "On-Time Delivery",
      description:
        "Our team values deadlines and ensures your projects are delivered on time, every time.",
      icon: Clock,
    },
    {
      title: "Expert Team",
      description:
        "Work with a skilled and passionate team dedicated to providing top-notch solutions.",
      icon: Users,
    },
    {
      title: "Fast Performance",
      description:
        "Optimized solutions built with speed and efficiency in mind for the best user experience.",
      icon: Zap,
    },
    {
      title: "Global Reach",
      description:
        "We serve clients worldwide with solutions tailored for different markets and needs.",
      icon: Globe,
    },
    {
      title: "24/7 Support",
      description:
        "Our support team is available round the clock to assist you whenever you need help.",
      icon: Headphones,
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-l from-[#1B2435] to-black">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Why Choose <span className="text-yellow-300">IntegralX</span>?
          </h2>
          <p className="mt-4 text-base md:text-lg text-gray-300">
            We don't just build apps, we craft thoughtful, user-centered
            solutions that help your business grow and adapt for the future.
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 justify-center">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-yellow-400 transition-all duration-300 hover:shadow-lg max-w-xs mx-auto"
              >
                {Icon && <Icon className="w-12 h-12 text-yellow-400 mb-4" />}
                <h3 className="text-lg font-semibold text-white mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
